import React from 'react';
import { makeStyles } from '@material-ui/core';

import utahSealLogo from 'img/seal-of-utah.svg';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: '1.5em',
  },
  seal: {
    display: 'block',
    width: '100%',
    maxWidth: '150px',
    marginBottom: '2.5em',
  },
  qr: {
    display: 'block',
    width: '100%',
    maxWidth: '120px',
    marginBottom: '1.2em',
  },
  id: {
    color: theme.custom.danger,
    textTransform: 'uppercase',
    fontSize: '1.125em',
    margin: '0 0 0.35em',
    fontWeight: '400',
  },
  date: {
    margin: '0',
    fontSize: '1.125em',
  },
}));

const Side = () => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <img
        className={classes.seal}
        src={utahSealLogo}
        alt="The Great Seal of the State of Utah"
      />
      <img
        className={classes.qr}
        src="http://inspections-api-staging.brands.utah.gov/media/qr_code/1.png"
        alt="Media QR"
      />
      <h4 className={classes.id}>UDAF-BI-3</h4>
      <p className={classes.date}>August 11, 2020</p>
    </div>
  );
};

export default Side;
